=a<template>
	<div>
		<van-nav-bar title="详情" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiDetailCont">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
					<div v-for="item in list" class="card" :key="item.uuid">
						<template>
							<table class="layout">
								<tr>
									<td>{{item.produceOrderNo}}</td>
									<td>{{item.produceCustomerId}}</td>
									<td>{{item.inputTime}}</td>
								</tr>
								<tr v-for="obj in item.details" :key="obj.field1">
									<td>{{obj.field1}}</td>
									<td>{{obj.field2}}</td>
									<td>{{obj.field3}}</td>
								</tr>
								<tr>
									<td>{{item.barcode}}</td>
									<td>{{item.positionname}}</td>
								</tr>
							</table>
						</template>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	import {
		NavBar,
		Button,
		Toast,
		Icon,
		Dialog,
		Tab,
		Tabs,
		List,
		PullRefresh,
		Popup,
		Search
	} from 'vant';
	import moment from "moment";
	import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	export default {
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				pageIndex: 0,
				refreshing: false,
				fields:[],
				dictNames: ""
			};
		},
		components: {
			[NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
		},
		methods: {
			onClickLeft() {
			    this.$router.go(-1);
			},
			async onLoad() {
				this.pageIndex++;
				if(this.dictNames == ""){
					let resp = await barcodeService.getBarcodeFieldList();
					if (resp.data.Status == "1") {
						this.fields = resp.data.Data;
						if(this.fields.length > 0){
							let tempDict = "position.rad_position";
							this.fields.forEach(item => {
								if(item.type == "6"){
									tempDict += ",";
									tempDict += item.name;
									tempDict+= ".";
									tempDict += item.dictName;
								}
							});
							this.dictNames = tempDict;
						}else{
							this.dictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
						}
					}
				}
				let resp = await barcodeService.getInputList(this.pageIndex, "", this.dictNames);

				resp.data.Data.data.forEach(item => {
					item.inputTime = moment(item.inputTime).format('YYYY-MM-DD');
				});
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					let details = [];
					if(this.fields.length > 0){
						let length = this.fields.length;
						let detailItem = {};
						this.fields.forEach(function (obj, i) {
							if(obj.name == "pieces"){
								item[obj.name] = (item[obj.name] || "") + "片";
							}
							if(i%3 == 0){
								detailItem = {};
								if(obj.type == "6"){
									detailItem.field1 = item[obj.name+"name"] || "";
								}else{
									detailItem.field1 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 1){
								if(obj.type == "6"){
									detailItem.field2 = item[obj.name+"name"] || "";
								}else{
									detailItem.field2 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 2){
								if(obj.type == "6"){
									detailItem.field3 = item[obj.name+"name"] || "";
								}else{
									detailItem.field3 = item[obj.name] || "";
								}
								details.push(detailItem);
							}
						});
					}else{
						details.push({
							field1: item.radCategoryname,
							field2: item.radIdname,
							field3: item.pieces + "片"
						});
						details.push({
							field1: item.centerCategoryname,
							field2: item.centerSpacing,
							field3: item.calibername
						});
						details.push({
							field1: item.colorname,
							field2: item.waterFlowname,
							field3: item.isSpecials || ""
						});
					}
					item.details = details;
				});
        		this.loading = false;
        		this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			}
		}
	}
</script>

<style scoped>
	.psiDetailCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
	}
	.spanBox {
		margin:0 20px;
	}
	
</style>
